import { IAction } from 'core/interface/action';

export type ShareProfileResponse = {
  id: number;
  candidate: number;
  share_url: string;
  expires: string;
  expired: boolean;
};

export const SAVE_URL = 'save-share-url';

const defaultState = {
  shareURLprofile: null,
  shareURLId: null
};

export const SaveShareProfileURL = (value: ShareProfileResponse) => ({
  type: SAVE_URL,
  payload: value
});

const shareProfileURLReducer = (
  state = defaultState,
  action: IAction<ShareProfileResponse>
) => {
  switch (action.type) {
    case SAVE_URL:
      return {
        ...state,
        shareURLprofile: action.payload.share_url,
        shareURLId: action.payload.id
      };

    default:
      return state;
  }
};

export default shareProfileURLReducer;
